import React, { useState, useEffect } from 'react';
import { TextField } from '@material-ui/core';
import { formatMoney, handleErrorToast } from '../../../../shared/Functions';
import { TokensVService, BillingAccountsVService, FeeTypeEnum, PaymentChannel } from '../../../../../services/V2/gozer';
import { CCProcessorEnum, PaymentConfigsVService, DistrictsVService, TerminalConfigsVService } from '../../../../../services/V2/padre';
import { FormController } from '../../../../shared/FormController';
import { $CCPaymentInitializeTerminalSale,
         $CCTokenInitializeTerminalRequest,
         $CCTokenRetrieveTerminalToken,
         $CCPaymentRetrieveTerminalSaleRequest,
         TerminalsVService} from '../../../../../services/V2/longhorn';

export function TerminalPayment({ districtId, billingAccountId, successCallback, failureCallback, step, setStepName, handleRefresh, setStep }) {
    const [model, setModel] = useState<any>({});
    const [next, setNext] = useState<boolean>(true);
    const [billingAccount, setBillingAccount] = useState<any>({});
    const [terminals, setTerminals] = useState<any[]>([]);
    const [result, setResult] = useState<any>({});
    const [terminalId, setTerminalId] = useState<string>("");
    const [operatorId, setOperatorId] = useState<string>("");
    const [paymentSource, setPaymentSource] = useState<any>(undefined);
    const [stepOneKeys, setStepOneKeys] = useState<any>({});
    const [stepTwoKeys, setStepTwoKeys] = useState<any>({});
    const [canChangeTerminal, setCanChangeTerminal] = useState<boolean>(false);

    useEffect(() => {
        DistrictsVService.districtsVGetById(districtId)
            .then(d => setOperatorId(d.operatorId ?? ""))
            .catch(err => failureCallback(handleErrorToast(err)))
        PaymentConfigsVService.paymentConfigsVGetDistrictPaymentConfig(districtId)
            .then(c => {
                if(c.ccProcessorId === CCProcessorEnum.PACE_EVEREST) setCanChangeTerminal(true)
                else setStep(2)
                setPaymentSource(c.ccProcessorId)
                setStepOneKeys(c.ccProcessorId === CCProcessorEnum.PACE_EVEREST ?
                        $CCTokenInitializeTerminalRequest.properties :
                        CCProcessorEnum.PACE_TRANSAFE ?
                            $CCPaymentInitializeTerminalSale.properties : null)
                setStepTwoKeys(c.ccProcessorId === CCProcessorEnum.PACE_EVEREST ?
                        $CCTokenRetrieveTerminalToken.properties :
                        CCProcessorEnum.PACE_TRANSAFE ?
                            $CCPaymentRetrieveTerminalSaleRequest.properties : null)
            })
            .catch(err => failureCallback(handleErrorToast(err)))
    }, [districtId])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(!next || !operatorId || !Object.keys(stepOneKeys).length) return;
        setNext(false)
        var newModel = model;
        if(step === 2) {
            TerminalConfigsVService.terminalConfigsVGetAll(operatorId, {
                pageNumber:  1,
                orderBy:"Id",
                orderByDesc: true,
                filters: [{ 
                    property: "OperatorId",
                    value: operatorId
                }],

            }) 
                .then(t => setTerminals(t.items ??[]))
                .catch(err => failureCallback(handleErrorToast(err)));

            Object.keys(stepOneKeys).forEach(key => {
                if(stepOneKeys[key].type === 'boolean') {
                    newModel[key] = false;
                } else if(key === "DistrictId")
                    newModel[key] = districtId;
                else if(key === "BillingAccountId")
                    newModel[key] = billingAccountId;
                else
                    newModel[key] = "";
            });
        } else if(step === 3) {
            Object.keys(stepTwoKeys).forEach(key => {
                if(stepTwoKeys[key].type === 'boolean') {
                    newModel[key] = false;
                } else if(key === "BillingAccountId")
                    newModel[key] = billingAccountId;
                else if(key === "SessionId")
                    newModel[key] = result.SessionId;
                else if(key === "PendingPaymentTransactionId")
                    newModel[key] = result.PendingPaymentTransactionId;
                else if(!model[key])
                    newModel[key] = "";
            });
            setStepName("Process Payment")
        }
        setModel(newModel);
    }, [next, operatorId, stepOneKeys])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        BillingAccountsVService.billingAccountsVGetById(billingAccountId)
            .then(ba => setBillingAccount(ba))
            .catch(err => failureCallback(handleErrorToast(err)));
    }, [billingAccountId])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(step === 2) {
            setStepOneKeys(paymentSource === CCProcessorEnum.PACE_EVEREST ?
                $CCTokenInitializeTerminalRequest.properties :
                CCProcessorEnum.PACE_TRANSAFE ?
                    $CCPaymentInitializeTerminalSale.properties : null)
            setStepTwoKeys(paymentSource === CCProcessorEnum.PACE_EVEREST ?
                $CCTokenRetrieveTerminalToken.properties :
                CCProcessorEnum.PACE_TRANSAFE ?
                    $CCPaymentRetrieveTerminalSaleRequest.properties : null)
            setNext(true)
        } else if(step === 3) {
            switch(paymentSource) {
                case CCProcessorEnum.PACE_EVEREST:
                    TerminalsVService.terminalsVInitializeTerminal(terminalId, model)
                        .then(r => {
                            setResult(r)
                            setNext(true)
                        })
                        .catch(err => {
                            failureCallback(handleErrorToast(err))
                        });
                    break;
                case CCProcessorEnum.PACE_TRANSAFE:
                    TerminalsVService.terminalsVInitializeTerminalSale(terminalId, model)
                        .then(r => {
                            setResult(r)
                            setNext(true)
                        })
                        .catch(err => {
                            failureCallback(handleErrorToast(err))
                        });
                    break;
                default:
                    failureCallback("Terminal type is not implemented.")
            }
        } else if(step === 4) {
            let addModel = {};
            for (let obj in model) {
                if(model[obj] !== "")
                    addModel[obj] = model[obj];
            }
            let serviceFee = billingAccount.paymentInfo.cc;
            var amount = model.BaseAmount ?? model.Amount;
            let confirm = window.confirm(`You are about to charge ${formatMoney(amount)}${serviceFee && serviceFee.feeType !== FeeTypeEnum.NONE ?
                serviceFee.feeType === FeeTypeEnum.FLAT ? ` and service fee of ${formatMoney(serviceFee.fee)}`
                : serviceFee.feeType === FeeTypeEnum.PERCENTAGE ? ` and service fee of ${formatMoney((serviceFee.fee*.01)*amount)}` : "(An error has occured)"
                : ""} to inputted CC account. Are you sure?`);

            if(confirm === true && paymentSource === CCProcessorEnum.PACE_EVEREST) {
                TerminalsVService.terminalsVRetrieveTerminalToken(model)
                    .then(t => {
                        TokensVService.tokensVCharge(billingAccountId, t.id ?? "", { channel: PaymentChannel.TERMINAL, amount: model.BaseAmount })
                            .then(res => {
                                successCallback(res ? `Approval Code: ${res.approvalCode}.\nAmount approved: ${formatMoney(res.amount)}.\nService Fee Charged: ${formatMoney(res.serviceFeeAmount)}` : "Success message recieved, but no transaction data was included");
                                handleRefresh();
                            })
                            .catch(err => {
                                failureCallback(handleErrorToast(err))
                                handleRefresh();
                            });
                    })
                    .catch(err => {
                        failureCallback(handleErrorToast(err))
                        handleRefresh();
                    });
            } else if(confirm === true && paymentSource === CCProcessorEnum.PACE_TRANSAFE){
                TerminalsVService.terminalsVRetrieveTerminalSale(model)
                    .then(t => {
                        successCallback(`Approval Code: ${t?.transaction?.approvalCode}.\nAmount approved: ${formatMoney(t?.transaction?.amount)}.\nService Fee Charged: ${formatMoney(t?.transaction?.serviceFeeAmount)}`);
                        handleRefresh();
                    })
                    .catch(err => {
                        failureCallback(handleErrorToast(err))
                        handleRefresh();
                    });
            }
        }
    }, [step])// eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = event => {
        let value = event.target.value === "" ? null : event.target.value;

        setTerminalId(value.id)
    }

    return (
        <>
            {step === 1 && canChangeTerminal &&
                <TextField style={{ width: '100%', textAlign: 'left' }}
                    key="processor"
                    select
                    onChange={e => setPaymentSource(e?.target?.value ?? CCProcessorEnum.PACE_EVEREST)}
                    required={true}
                    margin="normal"
                    name="Processor"
                    label="Processor"
                    type="string">
                    <option value={CCProcessorEnum.PACE_EVEREST}>
                        PACE_EVEREST
                    </option>
                    <option value={CCProcessorEnum.PACE_TRANSAFE}>
                        PACE_TRANSAFE
                    </option>
                </TextField>
            }
            {step === 2 &&
                <>
                    <TextField style={{ width: '100%', textAlign: 'left' }}
                        key="terminal"
                        select
                        onChange={handleChange}
                        required={true}
                        margin="normal"
                        name="Terminal"
                        label="Terminal"
                        type="string"
                    >
                        {terminals.map((t, i) => {
                            if(t.ccProcessorId !== paymentSource)
                                return null;
                            return <option key={`${i}-term`} value={t}>
                                    {t.nickname}
                                </option>
                        })}
                    </TextField>
                    <FormController
                        keys={stepOneKeys}
                        disabledKeys={["DistrictId", "BillingAccountId"]}
                        extraKeys={null}
                        editMode={true}
                        model={model}
                        setModel={setModel}
                        canReadUserRoles={false}
                        canReadMeters={null}
                        canReadServiceAddresses={null}
                        districtId={null} />
                </>
            }
            {step === 3 &&
                <FormController
                    keys={stepTwoKeys}
                    disabledKeys={["DistrictId", "BillingAccountId", "SessionId", "PendingPaymentTransactionId"]}
                    extraKeys={paymentSource === CCProcessorEnum.PACE_EVEREST ? {
                        IsSaved: {
                            type: 'boolean'
                    }} : null}
                    editMode={true}
                    model={model}
                    setModel={setModel}
                    canReadUserRoles={false}
                    canReadMeters={null}
                    canReadServiceAddresses={null}
                    districtId={null} />
            }
        </>
    );
}